import React from 'react';
import Modal from '@/components/layout/Modal';
import VBox from '@/components/layout/VBox';
import Icon from '@/components/Icon';
import { mdiLifebuoy, mdiWhatsapp } from '@mdi/js';

type ModalAjudaProps = {
    show: boolean;
    onClose: () => void;
};

const ModalAjuda: React.FC<ModalAjudaProps> = ({ show, onClose }) => {
    return (
        <Modal
            size="sm"
            title="Ajuda"
            show={show}
            onClose={onClose}
            onCancel={onClose}
            hideControls
        >
            <VBox gap="0" center style={{ padding: '24px 16px 32px' }}>
                {/* Ícone de destaque */}
                <div style={{
                    width: '72px',
                    height: '72px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--tc-color-primary-100, #e8f4ff)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px',
                }}>
                    <Icon path={mdiLifebuoy} size={2} color="var(--tc-color-brand-primary)" />
                </div>

                {/* Título */}
                <p style={{
                    margin: '0 0 8px',
                    fontWeight: 700,
                    fontSize: '1.15rem',
                    color: 'var(--tc-color-gray-900, #111)',
                    textAlign: 'center',
                }}>
                    Estamos aqui para ajudar!
                </p>

                {/* Subtítulo */}
                <p style={{
                    margin: '0 0 24px',
                    fontSize: '0.9rem',
                    color: 'var(--tc-color-gray-600, #666)',
                    textAlign: 'center',
                    lineHeight: 1.5,
                }}>
                    Dúvidas ou problemas? Nossa equipe está pronta para te atender pelo WhatsApp.
                </p>

                {/* Botão WhatsApp */}
                <a
                    href="https://wa.me/556223980147"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        alignSelf: 'center',
                        backgroundColor: '#25D366',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '0.95rem',
                        padding: '10px 24px',
                        borderRadius: '32px',
                        textDecoration: 'none',
                        boxShadow: '0 2px 8px rgba(37,211,102,0.35)',
                        transition: 'opacity 0.15s',
                    }}
                    onMouseOver={e => (e.currentTarget.style.opacity = '0.85')}
                    onMouseOut={e => (e.currentTarget.style.opacity = '1')}
                >
                    <Icon path={mdiWhatsapp} size={0.9} color="#fff" />
                    Falar no WhatsApp
                </a>
            </VBox>
        </Modal>
    );
};

export default ModalAjuda;
